import { Box, Card, CardContent, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Button, Icon } from "@designboticteam/react/components";

type Props = React.PropsWithChildren<{
	title?: string;
	isCollapsible?: boolean;
	isCollapsedByDefault?: boolean;
}>;

const Section = ({ children, title, isCollapsible, isCollapsedByDefault = false }: Props): React.ReactNode => {
	const [isCollapsed, setIsCollapsed] = useState(isCollapsedByDefault);

	return (
		<Card>
			<CardContent sx={{ paddingBottom: "16px!important" }}>
				<Stack direction="column">
					<Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
						{title && (
							<Typography variant="h6" sx={{ padding: 0 }}>
								{title}
							</Typography>
						)}
						{isCollapsible && (
							<Button
								size="small"
								icon={<Icon name={isCollapsed === false ? "collapse" : "uncollapse"} />}
								onClick={() => {
									setIsCollapsed((value) => !value);
								}}
							/>
						)}
					</Stack>

					<Collapse in={isCollapsed === false}>
						<Box sx={{ paddingTop: 2 }}>{children}</Box>
					</Collapse>
				</Stack>
			</CardContent>
		</Card>
	);
};

export { Section };
